export default __webpack_public_path__ + "static/media/7fa94155c38618993357fc46523c8c96.0dfb4a8f.png";